import { extendTheme } from '@chakra-ui/react';

const theme = {
    defaultProps: {
        size: 'md',
    }
};

export default theme